/**
 * Builds a redirect URL, preserving query parameters while optionally removing restoration params
 * @param basePath - The base path to redirect to
 * @param searchParams - Current search params from URL
 * @param removeRestorationParams - Whether to remove AC_ID and formName from params (default: true)
 * @returns Clean URL string with pathname and query string
 */
export function buildRedirectUrl(
  basePath: string,
  searchParams: URLSearchParams,
  removeRestorationParams = true,
): string {
  const origin = globalThis.window?.location.origin ?? "http://localhost";
  const url = new URL(basePath, origin);

  searchParams.forEach((value, key) => {
    if (removeRestorationParams && (key === "AC_ID" || key === "formName")) {
      return;
    }
    url.searchParams.set(key, value);
  });

  return url.pathname + url.search;
}
